import { __decorate } from "tslib";
import * as React from 'react';
import warning from 'choerodon-ui/lib/_util/warning';
import { observer } from 'mobx-react';
import Base from './Base';
import { FormField } from '../field/FormField';
const tupleNum = (...args) => args;
const TITLE_ELE_LIST = tupleNum(1, 2, 3, 4, 5);
let Title = class Title extends FormField {
    renderWrapper() {
        const { level = 1, children, ...restProps } = this.props;
        let component;
        if (TITLE_ELE_LIST.indexOf(level) !== -1) {
            component = `h${level}`;
        }
        else {
            warning(false, 'Typography.Title Title only accept `1 | 2 | 3 | 4 | 5` as `level` value.');
            component = 'h1';
        }
        return (React.createElement(React.Fragment, null,
            React.createElement(Base, Object.assign({}, restProps, { component: component }), this.processRenderer(this.getValue()) || children),
            this.renderFloatLabel()));
    }
};
Title.displayName = 'Title';
Title.__PRO_TEXT = true;
Title.defaultProps = {
    ...FormField.defaultProps,
    suffixCls: 'title',
};
Title = __decorate([
    observer
], Title);
export default Title;
